import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { AboutCourtFeesUserPaymentMapper } from '../../models-mapper/about-court-fees/fees-userpayment.mapper';
import { AboutCourtFeesMapper } from '../../models-mapper/about-court-fees/fees.mapper';
import { AboutCourtFeesUserDetailMapper } from '../../models-mapper/about-court-fees/frees-user-detail.mapper';
import { PaymentCoustFeesMapper } from '../../models-mapper/about-court-fees/patment-court-fees.mapper';
import { SaveTempRefMapper } from '../../models-mapper/lawsuit/ref-save-temp.mapper';
import { InputSearchTestifyMapper } from '../../models-mapper/testify/input-search-testify.mapper';
import { TestifyDefualtMapper } from '../../models-mapper/testify/testify-defualt.mapper';
import { genBillPdfApiModel, GetBillApiModel, PayCourtFeeApisModel, PayCourtFeeDetailApisModel, PaymentCheckApiModel, PaymentCourtFeesApiModel, RefCodeCheckApiModel, saveAppealPayApiModel, UserDetailAboutCourtFeesApisModel } from '../../models/about-court-fee/about-court-fees';
import { LawsuitRefApiModel } from '../../models/lawsuit/lawsuit';
import { paymentPathModel } from '../../models/shared/commone.model';
import { AboutCourtFeesModel, DataServiceModel, genBillPdfModel, GetBillModel, inputPaymentModel, PaymentCheckModel, PaymentCourtFeesModel, SummaryPaymentDetailModel, UserDetailAboutCourtFeesModel } from '../../view-models/about-court-fees';
import { inputSearchModel, RefinputResModel, RefinputSearchModel } from '../../view-models/conferencing';
import { GetLawsuitRefViewModel, LawSuitReqModel } from '../../view-models/lawsuit';
import { MethodModel, PayCourtFeeDetailModel, PayCourtFeeModel, PaySummayModel, SavePayCourtFeeModel } from '../../view-models/payfee';
import { TestifyModel } from '../../view-models/testify';
import { statusConst } from '../../_static/status.const';
import { dataPaymentCourtFees } from '../auth/_mock/mock-dataPaymentCourtFees.const';
import { DataGetBillModel } from '../auth/_mock/mock-getbill.const';
import { UserDataPayfees } from '../auth/_mock/mock-userdatapayfees.const';
import { userDataSummayPayment } from '../auth/_mock/mock-userdatasummarypement.const';
import { PaySummayMock } from '../auth/_mock/summary-payment-detail.const';

@Injectable({
  providedIn: 'root'
})
export class AboutCourtFeesService {

  constructor(
    private apiService: ApiService,
    private aboutCourtFeesMapper: AboutCourtFeesMapper,
    private testifyDefualtMapper: TestifyDefualtMapper,
    private saveTempRefMapper: SaveTempRefMapper,
    private aboutCourtFeesUserPaymentMapper: AboutCourtFeesUserPaymentMapper,
    private inputSearchTestifyMapper: InputSearchTestifyMapper,
    private paymentCoustFeesMapper: PaymentCoustFeesMapper

  ) { }

  async testifyCheck(item: inputSearchModel): Promise<PaymentCheckModel> {
    const request = this.inputSearchTestifyMapper.mapTo(item);
    const result = await this.apiService.patch<PaymentCheckApiModel>(`/payment/check`, request);
    return result!;
  }
  async testifyCheckRef(item: RefinputSearchModel): Promise<number> {
    // const request ={
    //   refCode : item.refCode
    // }
    const result = await this.apiService.get<RefinputResModel>(`/payment/acc/ref/${item.refCode}/get`);
    return result!.caseId;
  }

  async RefCodeCheckBlackNo(item:RefinputSearchModel):Promise<RefCodeCheckApiModel>{
    const request = {
      refCode : item.refCode
    }
    const result = await this.apiService.patch<RefCodeCheckApiModel>(`/payment/check-blackno`,request)
    return result!
  }

  async get(item: TestifyModel): Promise<PayCourtFeeModel> {
    const result = await this.apiService.get<PayCourtFeeApisModel>(`/payment/acc/suitBlackNo/${item.suitBlackCode}/suitBlackYear/${item.suitBlackYear}/cId/${item.administrativeCourt}/secId/${item.blackNumberCase}/suitId/${item.suitID}/get`);
    result?.accList.forEach(x=>{
      if(x.accCapital == null && x.accFee == null){
        x.accCapital = 0
        x.accFee = 0
      }
    })
    return result!
  }

  async savePay(item: SavePayCourtFeeModel): Promise<number> {
    const result = await this.apiService.patch<number>(`/payment/create-temp/additional-payment`,item);
    return result!
  }


  get isAppealEnum() {
    return statusConst.isAppealEnum
  }
  
  async getMethod(caseId: number,isShowPayMethod :boolean,isAppeal:number = 0): Promise<MethodModel> {
    const request = {
      caseId:caseId,
      isShowPayMethod:isShowPayMethod
    }
    const requestAppeal = {
      appId:caseId,
      isShowPayMethod:isShowPayMethod
    }
    let result:any
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.post<MethodModel>(`/payment/get-method`,request);}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.post<MethodModel>(`/payment/appeal-case/get-method`,requestAppeal);}
    return result!
  }
  async upDateMethod(caseId: number, item: MethodModel,isAppeal:number = 0): Promise<number> {
    const req = {
      caseId: Number(caseId),
      payMethod: item.payMethod,
      suitFeeType: item.suitFeeType
    }
    const reqAppeal = {
      appId: Number(caseId),
      payMethod: item.payMethod,
      suitFeeType: item.suitFeeType
    }
    let result:any
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.patch<number>(`/payment/update-method`, req);}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.patch<number>(`/payment/appeal-case/update-method`, reqAppeal);}
    return result!;
  }

  async genBillPdf(caseId: number,billId: number,isAppeal:number = 0):Promise<genBillPdfModel>{
    let result:any
    let appId = caseId
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.get<genBillPdfApiModel>(`/payment/case/${caseId}/bill/${billId}`)}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.get<genBillPdfApiModel>(`/payment/appeal-case/case/${appId}/bill/${billId}`)}
    return result!
  }

  
  async getBill(payCode:string): Promise<GetBillModel> {
    //const result = DataGetBillModel
    const result = await this.apiService.get<GetBillApiModel>(`/payment/bill/${payCode}`)
    return result!

  }

  async getDetail(caseId: number,isAppeal:number = 0): Promise<PayCourtFeeDetailModel> {
    let appId = caseId
    let result:any
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.get<PayCourtFeeDetailApisModel>(`/payment/detail/${caseId}/get`);}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.get<PayCourtFeeDetailApisModel>(`/payment/appeal-case/detail/${appId}/get`);}
    return result!
  }

  async getAcc(caseId: number,isAppeal:number = 0): Promise<PayCourtFeeModel> {
    let result:any
    let appId = caseId
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.get<PayCourtFeeDetailApisModel>(`/payment/acc/${caseId}/get`);}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.get<PayCourtFeeDetailApisModel>(`/payment/appeal-case/acc/${appId}/get`);}
    return result!
  }


  async createTempPay(caseId: number, accId: number,isAppeal:number = 0): Promise<number> {
    let result:any
    const req = {
      caseId: Number(caseId),
      accId: Number(accId),
    }
    const reqAppeal = {
      appId: Number(caseId),
      accId: Number(accId),
    }
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.patch<number>(`/payment/create-temp`, req);}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.patch<number>(`/payment/appeal-case/create-temp`, reqAppeal);}
  
    return result!;
  }
  async createTempPayAll(caseId: number,isAppeal:number = 0): Promise<number> {
    let result:any
    const req = {
      caseId: Number(caseId)
    }
    const reqAppeal = {
      appId: Number(caseId),
    }
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.patch<number>(`/payment/create-temp/pay-all`, req);}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.patch<number>(`/payment/appeal-case/create-temp/pay-all`, reqAppeal);}
    return result!;
  }

  
  
  async getMethodFee(addFeeId: number,caseId:number,IsShowPayMethod:boolean): Promise<MethodModel> {
    const request = {
      caseId:Number(caseId),
      IsShowPayMethod:IsShowPayMethod
    }
    const result = await this.apiService.post<MethodModel>(`/payment/additional-fees/get-method/${addFeeId}`,request);
    return result!
  }
  async upDateMethodFee(addFeeId: number, item: MethodModel): Promise<number> {
    const req = {
      addFeeId: Number(addFeeId),
      payMethod: item.payMethod,
      suitFeeType: item.suitFeeType
    }
    const result = await this.apiService.patch<number>(`/payment/additional-fees/method/update`, req);
    return result!;
  }
  async getDetailFee(addFeeId: number): Promise<PayCourtFeeDetailModel> {
    const result = await this.apiService.get<PayCourtFeeDetailApisModel>(`/payment/get-detail/${addFeeId}`);
    return result!
  }

  async getAccFee(addFeeId: number): Promise<PayCourtFeeModel> {
    const result = await this.apiService.get<PayCourtFeeApisModel>(`/payment/get-acc/${addFeeId}`);
    return result!
  }
  async createTempPayFee(addFeeId: number, accId: number): Promise<number> {
    const req = {
      addFeeId: Number(addFeeId),
      accId: Number(accId),
    }
    const result = await this.apiService.patch<number>(`/payment/additional-fees/create-temp`, req);
    return result!;
  }
  async createTempPayFeeAll(addFeeId: number): Promise<number> {
    const req = {
      addFeeId: Number(addFeeId)
    }
    const result = await this.apiService.patch<number>(`/payment/additional-fees/create-temp/pay-all`, req);
    return result!;
  }
  async getBillFeeTemp(addFeeId:number,billId:number): Promise<PaymentCourtFeesModel>{

    const result = await this.apiService.get<PaymentCourtFeesApiModel>(`/payment/additional-fees/temp/addFee/${addFeeId}/billId/${billId}`)
    return this.paymentCoustFeesMapper.mapForm(result!)
   }


  async getUser(): Promise<inputPaymentModel> {
    const result = UserDataPayfees
    //return this.aboutCourtFeesUserPaymentMapper.mapForm(result!)
    return result

  }

  async paymentGetUser(): Promise<PaymentCourtFeesModel>{
    const result = dataPaymentCourtFees
    return result
  }

   async getBillTemp(caseId:number,billId:number,isAppeal:number = 0): Promise<PaymentCourtFeesModel>{
    let result:any
    let appId = caseId
    if(isAppeal == this.isAppealEnum.no){result = await this.apiService.get<PaymentCourtFeesApiModel>(`/payment/temp/case/${caseId}/billId/${billId}`)}
    if(isAppeal == this.isAppealEnum.yes){result = await this.apiService.get<PaymentCourtFeesApiModel>(`/payment/appeal-case/temp/case/${appId}/billId/${billId}`)}
    return this.paymentCoustFeesMapper.mapForm(result!)
   }

  async summaryPaymentGetUser(): Promise<SummaryPaymentDetailModel> {
    const result = userDataSummayPayment
    //return this.summaryPaymentDetailMapper.mapForm(result!)
    return result

  }

  async saveUser(item: inputPaymentModel): Promise<inputPaymentModel> {
    const result = this.aboutCourtFeesUserPaymentMapper.mapTo(item)
    return result!

  }



 
  async saveTemp(item: AboutCourtFeesModel): Promise<boolean> {
    const request = this.aboutCourtFeesMapper.mapTo(item);
    const result = await this.apiService.patch<boolean>(`/about-court-fees/save-temp`, request);
    return result!;
  }

  async saveTempRef(item: LawSuitReqModel): Promise<boolean> {
    const reqId = item.reQID
    const request = this.saveTempRefMapper.mapTo(item);
    const result = await this.apiService.post<boolean>(`/indictment/amend/${reqId}/ref/temp`, request);
    return result!;
  }

  async getRefTemp(reqId: number): Promise<GetLawsuitRefViewModel> {
    const result = await this.apiService.get<LawsuitRefApiModel>(`/indictment/amend/${reqId}/ref/temp`);
    return result!
    // return this.testifyDefualtMapper.mapForm(result!);
  }

  async getDefualt(courntId: number): Promise<any> {
    const result = await this.apiService.get<any>(`/indictment/amend/${courntId}/get-default`);
    if (result != false) { return this.testifyDefualtMapper.mapForm(result!); }
    return false
  }


  async save(c_id: number, sec_id: number, suit_id: number, req_id: number, remark: string): Promise<boolean> {
    const request = {
      dtL_CROP: remark
    }
    const result = await this.apiService.patch<boolean>(`/about-court-fees/court/${c_id}/section/${sec_id}/suit/${suit_id}/request/${req_id}/save`, request);
    return result!;
  }

  async saveRef(refCode: string, req_id: number, remark: string): Promise<boolean> {
    const request = {
      dtL_CROP: remark
    }
    const result = await this.apiService.patch<boolean>(`/indictment/amend/ref/${refCode}/request/${req_id}/save`, request);
    return result!;
  }
  async confirm(c_id: number, sec_id: number, suit_id: number, req_id: number): Promise<boolean> {

    const result = await this.apiService.patch<boolean>(`/about-court-fees/court/${c_id}/section/${sec_id}/suit/${suit_id}/request/${req_id}/confirm`);
    return result!;
  }
  async confirmRef(refCode: string, req_id: number): Promise<boolean> {
    const result = await this.apiService.patch<boolean>(`/indictment/amend/ref/${refCode}/request/${req_id}/confirm`);
    return result!;
  }

  async paymentCheckPath(refCode?:string,cId?:number,secId?:number,blackNo?:number,blackYear?:string):Promise<paymentPathModel>{
    const request = {
      refCode,cId,secId,blackNo,blackYear
    }
    const result = await this.apiService.patch<paymentPathModel>(`/payment/check-path`,request);
    return result!
  }

  async getPaymentSummaryDetail(cId:number,secId:number,suitId:number,caseId: number): Promise<PaySummayModel> {
    const request={
      cId,secId,suitId,caseId
    }
    const result = await this.apiService.post<PaySummayModel>(`/my-case/payment/fee-detail`,request);
    //const result = PaySummayMock
    return result!
  }

  async getAppealAuccser(item: DataServiceModel): Promise<PayCourtFeeModel> {
    const result = await this.apiService.patch<PayCourtFeeApisModel>(`/payment/additional/appeal-case/acc-user`,item);
    result?.accList.forEach(x=>{
      if(x.accCapital == null && x.accFee == null){
        x.accCapital = 0
        x.accFee = 0
      }
    })
    return result!
  }

  async saveAppealPay(item: SavePayCourtFeeModel): Promise<saveAppealPayApiModel> {
    const result = await this.apiService.patch<saveAppealPayApiModel>(`/payment/additional/appeal-case/create-temp`,item);
    return result!
  }
}
